// Sting Energy — Hindi Factory Process Decoder overlay composition.
// Base video is the WITH-INTRO cut (5s ad intro + 606s doc) → every doc anchor is
// shifted +5.0s via S(). Overlays: 3 red-glow BigStats (right-mid), 6 step chips
// (top-left), 1 bottom-center unit label, 3 CTAs, persistent channel logo bug.
// 16 fps · 1280×704 · composite onto sting_full_with_intro.mp4.
import React from "react";
import { AbsoluteFill, Sequence, Img, staticFile } from "remotion";
import { PaletteProvider, BigStat, Tag } from "./overlayKit";
import { STING_PALETTE } from "./StingFullPalette";
import { CTASubscribeBell } from "./cta/CTASubscribeBell";
import { CTACombinedBar } from "./cta/CTACombinedBar";

const FPS = 16;
const f = (s: number) => Math.round(s * FPS);
const SHIFT = 5.0;                 // ad-intro offset
const S = (s: number) => s + SHIFT; // doc-time → base-time

export const StingFullPreview: React.FC = () => (
  <PaletteProvider value={STING_PALETTE}>
    <AbsoluteFill>
      {/* persistent channel logo bug — New Project wordmark, from t=0 (covers the ad intro too) */}
      <Sequence from={0} layout="none">
        <AbsoluteFill style={{ justifyContent: "flex-start", alignItems: "flex-end", padding: 20 }}>
          <Img src={staticFile("new_project_logo.png")} style={{ width: 120, height: "auto", opacity: 1, filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.7))" }} />
        </AbsoluteFill>
      </Sequence>

      {/* ── BigStats — right edge, vertically centered, red glow ── */}
      <BigStat pos="right-mid" glow="#e2231a" color="primary" numberColor="neutral" numberSize={148}
        label="THE REAL 'ENERGY'" sub="OF THE WHOLE BOTTLE"
        value={0.03} decimals={2} suffix=" %" valueS={S(33.20)} endS={S(34.00)} outS={S(34.7)} />
      <BigStat pos="right-mid" glow="#e2231a" color="primary" numberColor="neutral"
        label="CAFFEINE PER BOTTLE" sub="A SPOON OF IT CAN KILL"
        value={150} suffix=" MG" valueS={S(173.06)} endS={S(174.26)} outS={S(176.6)} />
      <BigStat pos="right-mid" glow="#e2231a" color="primary" numberColor="neutral"
        label="FSSAI DAILY LIMIT" sub="MAX · ABOUT 2 BOTTLES"
        value={500} suffix=" ML" valueS={S(557.63)} endS={S(558.59)} outS={S(561.2)} />

      {/* ── Step chips — top-left, "STEP N" yellow + title white ── */}
      <Tag pos="top-left" color="primary" inS={S(86.27)} outS={S(89.8)} hi="STEP 1" label="FILTRATION" />
      <Tag pos="top-left" color="primary" inS={S(142.68)} outS={S(146.2)} hi="STEP 2" label="SYRUP ROOM" />
      <Tag pos="top-left" color="primary" inS={S(269.5)} outS={S(273.0)} hi="STEP 3" label="TESTING" />
      <Tag pos="top-left" color="primary" inS={S(346.87)} outS={S(350.4)} hi="STEP 4" label="CARBONATION" />
      <Tag pos="top-left" color="primary" inS={S(382.67)} outS={S(386.2)} hi="STEP 5" label="BOTTLE PACKAGING" />
      <Tag pos="top-left" color="primary" inS={S(420.03)} outS={S(423.6)} hi="FINAL STEP" label="PACKAGING & DISTRIBUTION" />

      {/* ── Unit label — bottom-center ── */}
      <Tag pos="bottom-center" color="primary" inS={S(125.4)} outS={S(128.8)} label="PARTS PER BILLION" />

      {/* ── CTAs (channel defaults to FACTORY PROCESS DECODER) ── */}
      <Sequence from={f(S(68.0))} durationInFrames={f(5.0)} layout="none"><CTASubscribeBell /></Sequence>
      <Sequence from={f(S(598.1))} durationInFrames={f(3.0)} layout="none"><CTACombinedBar /></Sequence>
      <Sequence from={f(S(601.1))} durationInFrames={f(4.5)} layout="none"><CTACombinedBar /></Sequence>
    </AbsoluteFill>
  </PaletteProvider>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
